import * as Yup from "yup";

import { variables } from "../Variables";

const { required, IsEmail, IsNum, numReg } = variables;

export const signupValidation = Yup.object({
  email: Yup.string().required(required).email(IsEmail),
  firstName: Yup.string().required(required),
  lastName: Yup.string().required(required),
  phoneNumber: Yup.number().required(required),
  bvn: Yup.string().matches(numReg, IsNum).required(required),
  password: Yup.string()
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
      "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
    )
    .required(required),
  confirmPassword: Yup.string()
    .required(required)
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
      "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
    )
    .oneOf([Yup.ref("password"), null], "Passwords must match"),
});
